"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processOrder = void 0;
const helpers_1 = require("../../helpers");
const sendEmail_1 = require("../sendEmail");
const addOrderLog_1 = require("./addOrderLog");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderById_1 = require("./getOrderById");
const updateOrderLineVersion_1 = require("./updateOrderLineVersion");
const processOrder = async (supabase, order_obj, old_order_obj) => {
    const order = await (0, getOrderById_1.getOrderById)(supabase, order_obj.id);
    const order_lines = order.order_lines;
    // only process if the order status has changed between the old and new order
    if (old_order_obj.status === order_obj.status)
        return;
    switch (order.status) {
        case helpers_1.OrderStatus.QUOTE: {
            if (!order_lines)
                return;
            // Update all order lines to PENDING_CLIENT_APPROVAL
            for (const order_line of order_lines) {
                if (!order_line.versions)
                    continue;
                const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(order_line.versions);
                if (!latest_version)
                    continue;
                latest_version.status = helpers_1.OrderLineStatus.PENDING_CLIENT_APPROVAL;
                await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, latest_version);
            }
            await (0, addOrderLog_1.addOrderLog)(supabase, {
                created_by: order.client?.id,
                type: "ORDER",
                order_id: order?.id,
                detail: {
                    type: "Order Status Update",
                    status: "QUOTE",
                    title: order.reference,
                    message: `Order converted to quote`,
                },
            });
            const new_quote_email = {
                language_code: "en",
                template_id: helpers_1.EMAIL_CLIENT_QUOTE,
                order_id: order.id,
            };
            // Send email to customer
            await (0, sendEmail_1.sendEmail)(new_quote_email);
            break;
        }
    }
};
exports.processOrder = processOrder;
